class Constantes {

  /** Habilita/deshabilita los logs de depuración en consola */
  static DEBUG_ENABLED = true;

  static URL_BASE = "http://localhost";
  static PORT_MAP = {
    "": "",
    "80": "80",
    "443": "443",
    // Gate integrado ai-dev: React y REST se sirven desde el mismo Payara.
    "18080": "18080",
    "other": "8080"
  };
  static API_BASE = "api";

  static URL_CCO = "";
  static URL_SSO = "singlesignon/";
  static URL_BOX = "boxconv/";
  static URL_CCON = "cubiconta/";
  static URL_CUBE = "Cuberite/";
  static URL_TABL = "tablerite/";
  static URL_HAPK = "hapkiapp/";
  static URL_TEAN = "teansari/";
  static URL_MUGIN = "mugin/";
  static URL_MFM = "media/";
  static URL_EXHI = "exhi/";
  static URL_CHAMP = "champ/";
  static URL_MTA = "meetthemall/";
  static URL_CC = "";

  static TEAN_ORIGINS = ["127.0.0.1", "teansari.zapto.org", "teansari.cubiclan.com", "teansaritest"];
  static MUGIN_ORIGINS = ["mugin.zapto.org", "mugin.cubiclan.com", "mugintest"];
  static HAPK_ORIGINS = ["hapkiapp.zapto.org", "hapktest"];

  static CUBERITE_TITLE = "Cuberite";
  static TEANSARI_TITLE = "Teansari";
  static MUGIN_TITLE = "MUGIN";
  static HAPKIAPP_TITLE = "HapkiApp";

  static APPS_IMGS_MAP = new Map([
    ['CCON', 'images/ccoimg.jpeg'],
    ['app2', 'path/to/app2-image.ico'],
    ['app3', 'path/to/app3-image.ico']
]);
}

export default Constantes;
